import { render, staticRenderFns } from "./m-prices.vue?vue&type=template&id=8826473c&scoped=true"
import script from "./m-prices.vue?vue&type=script&lang=js"
export * from "./m-prices.vue?vue&type=script&lang=js"
import style0 from "./m-prices.vue?vue&type=style&index=0&id=8826473c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8826473c",
  null
  
)

export default component.exports